export default __webpack_public_path__ + "static/media/14_lapac_PetraFiserova-min.817c83bd.jpg";